<template>
  <vue-draggable-resizable
    :w="width"
    :h="height"
    :x="posX"
    :y="posY"
    @dragstop="onDragStop"
    :max-width="890"
    :max-height="700"
    :min-width="300"
    @resizing="onResizing"
    :active="true"
    :parent="true"
    :resizable="isResizing"
    :drag-handle="'.drag'"
    :draggable="draggable"
    class-name-handle="object-form-resizable-handle"
    :key="posX"
    style="z-index: 100;"
  >
    <div
      class="home-floating-window-container drag elevation-1"
      :style="{ height: height }"
      :key="height + width"
      id="window"
    >
      <v-layout row justify-space-between class="home-floating-window-header">
        <v-layout row justify-start align-center>
          <slot name="iconWindows" />
          {{ title }}
        </v-layout>

        <window-header-button @onClick="closeWindows" mode="dark" />
      </v-layout>

      <v-divider style="margin: 0 20px" />

      <slot name="objectDivWindows" />
    </div>
  </vue-draggable-resizable>
</template>

<script>
import WindowHeaderButton from "@/components/_Atoms/WindowHeaderButton";
export default {
  name: "HomeFloatingWindow",

  components: { WindowHeaderButton },

  props: {
    title: {
      type: String,
      required: true
    },

    draggable: {
      type: Boolean,
      default: true,
      required: false
    },

    height: {
      type: Number,
      default: 350
    },

    width: {
      type: Number,
      default: 300
    },

    isResizing: {
      type: Boolean,
      default: false
    },

    circuit: {
      type: Object,
      required: false
    }
  },

  data() {
    return {
      minHeight: 300,
      posX: 700,
      posY: 100
    };
  },

  watch: {
    circuit() {
      setTimeout(() => {
        let element = document.getElementsByClassName(
          "home-floating-window-container drag elevation-1"
        )[1];
        this.minHeight = element.clientHeight;
      }, 500);
    }
  },

  methods: {
    closeWindows() {
      this.$emit("close");
    },

    onDragStop(x, y) {
      this.$emit("changePosition", { x: x, y: y });
    },

    onResizing(left, top, width, height) {
      this.$emit("changeSize", { height: height, width: width });
    }
  }
};
</script>

<style scoped>
.home-floating-window-container {
  position: absolute;
  min-height: 100%;
  max-width: 850px;
  background-color: white;
  z-index: 50;
  border-radius: 1px;
  height: fit-content;
  width: 100%;
}

.home-floating-window-header {
  padding: 10px 20px;
  height: 48px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/ObjectWindow/HomeFloatingWindow.vue